module.exports = __webpack_public_path__ + "media/slot-game/wine-bottle-21ffb03e.svg";